import styled from 'styled-components'
import Carousel from 'antd/lib/carousel'
import Card from '../Card'
import Icon from '../Icon'
import Select from '../Select'
import Form from '../Form'
import Input from '../Input'
import Button from '../Button'
require('antd/lib/carousel/style')

const StyledTimestamp = styled.span`
  align-self: flex-start;
  margin-left: 50px;
`

const StyledWidgetContainer = styled.div`
  --main-bg: #e00027;
  --faded-bg: #f2f2f2;
  --text-dark: #121212;
  --text-red: #e40712;

  && .rcw-widget-container {
    pointer-events: none;
    display: flex;
    justify-content: flex-end;
    height: 100%;

    .rcw-launcher {
      pointer-events: all;
    }
    .rcw-hide-sm {
      @media screen and (max-width: 800px) {
        display: none;
      }
    }
    .rcw-conversation-container {
      pointer-events: all;
      box-shadow: 0 5px 40px 0 rgba(0, 0, 0, 0.15)
    }
  }

  && .rcw-header {
    background-color: var(--main-bg);
    padding: 18px 0px;

    .rcw-close-button {
      top: 15px;
      right: 10px;
      background-color: unset;

      img {
        width: 15px;
        height: 15px;
      }
    }
    h4 {
      color: #ffffff;
      font-weight: bold;
      font-size: 16px;
      line-height: 1.5;
      padding: 0px;
    }
    span {
      display: none;
    }
  }
  && .rcw-sender {
    font-size: 14px;
    height: 60px;

    .rcw-new-message {
      height: 100%;
    }
  }
  && .rcw-message {
    position: relative;

    .rcw-client {
      .rcw-message-text {
        background-color: var(--main-bg);
        color: white;
        padding: 10px;

        p {
          font-size: 14px;
        }
      }
    }
  }
  && .rcw-launcher {
    background-color: var(--main-bg);
  }
  && .rcw-launcher .rcw-badge {
    background-color: var(--main-bg);
    color: #ffffff;
    font-weight: bold;
    border: 3px solid white;
    line-height: normal;
  }
  && .rcw-response {
    .rcw-message-text {
      background-color: var(--faded-bg);
      line-height: 1.33;
      color: var(--text-dark);
      padding: 10px;
      border-radius: 4px;

      p {
        font-size: 14px;
        margin: 0px;
      }
    }
  }
`
const StyledAgentContainer = styled.div`
  && {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
`
const StyledResponseContainer = styled.div`
  && {
    display: flex;
    flex-direction: column;
    width: 100%;

    .ant-carousel {
      margin-top: 8px;
      margin-left: 50px;
      margin-right: 10%;
    }
  }
  && .ninjachat-menu-btn {
    cursor: pointer;
    color: var(--text-red);
    font-size: 14px;
    letter-spacing: normal;
    text-transform: none;
    padding: 10px 16px;
    height: auto;
    white-space: normal;

    span {
      line-height: 20px;
    }

    && :hover :focus {
      color: var(--text-red);
    }
  }
  && .ninjachat-quick-reply-btn {
    color: var(--text-red);
    border-color: var(--main-bg);
    margin: 10px 5px 0px 5px;
    font-size: 14px;
    letter-spacing: normal;
    text-transform: none;
    height: unset;
    border-radius: 20px;
    padding: 10px;
    min-width: 48px;
    white-space: normal;

    span {
      line-height: 20px;
    }

    :hover {
      color: #ffffff;
      background-color: var(--main-bg);
    }
    :active {
      color: #ffffff;
      background-color: var(--main-bg);
    }
    :focus {
      color: #ffffff;
      background-color: var(--main-bg);
    }
  }
`
const StyledMessageContainer = styled.div`
  && {
    margin-left: 50px;
    margin-right: 10%;
  }
`
const StyledMessage = styled.div`
  && {
    background-color: var(--faded-bg);
    border-radius: 4px;
    line-height: 1.33;
    color: var(--text-dark);
    padding: 10px;
    width: ${props => props.fitContent ? 'fit-content' : 'unset'};

    p {
      font-size: 14px;
      margin: 0px;
    }
  }
`

const StyledMenuOptionsContainer = styled.div`
  && {
    display: flex;
    flex-direction: column;
    margin-left: 50px;
    margin-right: 10%;
  }
`
const StyledQuickReplyOptionsContainer = styled.div`
  && {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-left: 10%;
    margin-right: 0%;
  }
`

const StyledDropdown = styled(Select)`
  && {
    width: 100%;
    margin-top: 8px;
    margin-left: 5.5%;
    margin-right: 11%;
    z-index: 999;

    .ant-select-selection {
      border-color: #d9d9d9;
      box-shadow: unset;
    }
  }
`
const StyledDropdownOption = styled.div`
  && {
    color: var(--text-dark);
    display: block;
    padding: 5px 12px;
    font-size: 14px;
    width: 100%;
    height: auto;
    white-space: normal;
  }

  :hover {
    background-color: #f8f8f8;
  }
`

const StyledCarousel = styled(Carousel)`
  && {
    min-height: 150px;
  }
`
const StyledCarouselOptionContainer = styled.div`
  && {
    display: flex;
    flex-direction: column;
  }
`
const StyledCarouselOption = styled(Card)`
  && {
    background-color: var(--faded-bg);
    min-height: 120px;

    .ant-card-body {
      font-size: 14px;
    }
  }
`
const StyledCarouselIcon = styled(Icon).attrs({
  type: 'large',
  gap: 0,
  fixedWidth: true,
  color: '#bfbfbf'
})`
  font-size: 30px !important;
  display: flex;
  align-items: center;
  border-radius: 50%;
  background-color: white;
`

const StyledLauncherButton = styled.button`
  && {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
const StyledLauncherIcon = styled(Icon).attrs({
  type: 'large',
  gap: 0,
  fixedWidth: true,
  color: '#ffffff'
})`
  font-size: 32px !important;
  margin: 0px;
`

const StyledAttachmentContainer = styled.div`
  && {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 18px;
  }
`
const StyledAttachmentIcon = styled(Icon).attrs({
  type: 'large',
  fixedWidth: true
})`
  margin-left: 0;
  margin-right: 6px;
  font-size: 24px !important;
`

const StyledFormContainer = styled.div`
  && {
    margin-left: 50px;
    margin-top: 8px;
    margin-right: 5%;
    display: flex;
    flex-direction: column;
    padding: 10px;
    background-color: var(--faded-bg);
    border-radius: 4px;
  }
`
const StyledFormTitle = styled.span`
  && {
    font-size: 14px;
    color: var(--text-dark);
    font-weight: bold;
    line-height: 1.5;
  }
`
const StyledSectionTitle = styled.div`
  && {
    font-size: 14px;
    color: var(--text-dark);
    line-height: 1.5;
    margin: 4px 0px 4px 0px;
  }
`
const StyledFormSectionContainer = styled.div`
  && {
    display: flex;
    flex-direction: column;
  }
`
const StyledFormItem = styled(Form.Item)`
  && {
    margin-bottom: 0;

    .ant-form-item-label {
      label {
        font-size: 12px;
        line-height: 28px !important;
        color: #8c8c8c !important;
      }
    }

    .ant-form-item-control {
      line-height: 0px;
    }

    .ant-btn {
      :hover {
        background-color: #e00027;
      }
      :active {
        background-color: #ab0321;
      }
      :focus {
        background-color: #c70023;
      }
    }

    .ant-btn.ant-btn-loading {
      background-color: #d9d9d9;
      color: #fff;
    }
  }
`
const StyledFormInputOptionContainer = styled.div`
  && {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`
const StyledFormInput = styled(Input)`
  && {
    height: 32px !important;
    margin: 4px 0 0;
    padding: 6px 8px 6px 8px !important;
    border-radius: 4px;
    border: solid 1px #d9d9d9;
    font-size: 14px !important;
    line-height: 1.43;
    color: var(--text-dark);
  }
`
const StyledFormSubmitButton = styled(Button)`
  && {
    width: 100%;
    height: 40px;
    margin: 16px 0 0;
    padding: 8px 16px;
    border-radius: 4px;
    background-color: #c70023;

    span {
      font-size: 16px;
      font-weight: bold;
      line-height: 1.5;
      text-align: center;
      color: #fff;
      text-transform: none;
      letter-spacing: 0px;
    }
  }
`

export {
  StyledTimestamp,
  StyledWidgetContainer,
  StyledAgentContainer,
  StyledResponseContainer,
  StyledMessageContainer,
  StyledMessage,
  StyledMenuOptionsContainer,
  StyledQuickReplyOptionsContainer,
  StyledDropdown,
  StyledDropdownOption,
  StyledCarousel,
  StyledCarouselOptionContainer,
  StyledCarouselOption,
  StyledCarouselIcon,
  StyledLauncherButton,
  StyledLauncherIcon,
  StyledAttachmentContainer,
  StyledAttachmentIcon,
  StyledFormContainer,
  StyledFormTitle,
  StyledSectionTitle,
  StyledFormSectionContainer,
  StyledFormItem,
  StyledFormInputOptionContainer,
  StyledFormInput,
  StyledFormSubmitButton
}
